import * as React from 'react'
import { Badge } from 'react-bootstrap'

interface Props {
	color?: string
	textColor?: string
}
const NotificationBadge: React.FunctionComponent<Props> = (props) => {
	const backgroundColor = props.color || '#E06161'

	const styles: {
		backgroundColor: string
		borderRadius: string
		padding: string
		color?: string
	} = {
		backgroundColor,
		borderRadius: '4px',
		padding: '7px 9px 7px 9px',
	}
	if (props.textColor) {
		styles.color = props.textColor
	}

	return <Badge style={styles}>{props.children}</Badge>
}

export default NotificationBadge
